import cls from 'classnames';

import SvgIcon from '../SvgIcon';

import IHistoryButtonsProps from './types';
import useStyles from './styles';

export default function HistoryButtons({
  className,
  onBackwardsClick,
  onForwardClick,
  backwardsDisabled,
  forwardDisabled,
}: IHistoryButtonsProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, className)}>
      <button
        className={cls(classes.btn, classes.spaced, backwardsDisabled && classes.disabled)}
        disabled={backwardsDisabled}
        onClick={onBackwardsClick}
      >
        <SvgIcon name="cp-undo-editor-gen" />
      </button>
      <button
        className={cls(classes.btn, forwardDisabled && classes.disabled)}
        disabled={forwardDisabled}
        onClick={onForwardClick}
      >
        <SvgIcon name="cp-redo-editor-gen" />
      </button>
    </div>
  );
}
